import { getScheduleForWeekUrl } from 'services/navigation';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';

export const useScheduleConfigurationPage = () => {
  return {
    breadcrumbs: [
      homeBreadcrumbItem,
      {
        title: 'Расписание на неделю',
        url: getScheduleForWeekUrl(),
      },
      {
        title: 'Настройка конфигурации',
        url: '',
      },
    ],
    breadcrumbsLoading: false,
  };
};
